import { usePage } from "@inertiajs/react";
import type { SharedBrand, SharedProps } from "@/types";

/**
 * The brand the page is wearing, or null on Driftables itself.
 *
 * On a branded site the chrome pares down (no sidebar; Events and Your
 * applications in the top bar) and nothing links to the pages it leaves out
 * (BrandedSiteAccess::ALLOWED): tracks, clubs, a car's or a media group's
 * page, breadcrumbs up through them. An admin's preview gets the same chrome,
 * so a demo looks like the real thing.
 */
export function useBrand(): SharedBrand | null {
  return usePage<SharedProps>().props.brand;
}
